/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SimpleSlide } from './SimpleSlide';
import type { UserName } from './UserName';

export type CaseEventLog = {
    readonly id?: number;
    case: number;
    readonly author?: UserName;
    readonly associated_user?: UserName;
    event: CaseEventLog.event;
    readonly created_at?: string;
    readonly slide?: SimpleSlide;
}

export namespace CaseEventLog {

    export enum event {
        RECEIVED_SIGN_OUT = 'received-sign-out',
        ACCESSION_DONE = 'accession-done',
        GROSS_DONE = 'gross-done',
        STAIN_ORDER_WPL = 'stain-order-wpl',
        RESCAN_ARCHIVAL = 'rescan-archival',
        RESCAN_QUALITY = 'rescan-quality',
        SLIDE_ADDED = 'slide-added',
        ARCHIVED_BY_CLINIC_RULE = 'archived-by-clinic-rule',
        SCREEN_DONE = 'screen-done',
        SIGNED_OUT = 'signed-out',
        AMENDED = 'amended',
        ADDENDED = 'addended',
        CORRECTED = 'corrected',
        PRELIMINARY = 'preliminary',
        ASSIGN_SCREENER = 'assign-screener',
        ASSIGN_SIGNER = 'assign-signer',
    }


}
